import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { generateCreateAccountToken } from '@src/api'
import { DefaultApiGenerateCreateAccountTokenRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

import { GenerateCreateAccountTokenError } from './type'

export const useGenerateCreateAccountToken = () => {
  const { axiosInstance } = useAxios({ shouldSkipLogout: true })

  return useMutation<
    unknown,
    AxiosResponse<GenerateCreateAccountTokenError>,
    DefaultApiGenerateCreateAccountTokenRequest
  >({
    mutationFn: (params: DefaultApiGenerateCreateAccountTokenRequest) =>
      generateCreateAccountToken(axiosInstance, params),
  })
}
